import { render, staticRenderFns } from "./AuditoriaInterna.vue?vue&type=template&id=6b071dc6&"
import script from "./AuditoriaInterna.vue?vue&type=script&lang=js&"
export * from "./AuditoriaInterna.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports